import * as React from 'react';
import cx from 'classnames';
import styles from './index.less';
import NaviBar from '@src/business-components/navibar';
import BaseLayoutStore from './store';
import wrapStore from '@src/utils/wrap-store';
import { useEffect } from 'react';
import LoadFont from '@src/pages/app-router/font.js';

const BaseLayout = ({ className, children, store }) => {
  store.use();
  const layoutRef = React.useRef(null);

  React.useEffect(() => {
    setTimeout(() => {
      LoadFont();
    }, 5000);
  }, []);

  useEffect(
    () => {
      if (layoutRef.current) {
        layoutRef.current.scrollTop = 0;
      }
    },
    [layoutRef]
  );

  return (
    <div className={cx(styles.root, className)}>
      <NaviBar store={store.naviBarStore} />
      <div id="pc-layout-main" ref={layoutRef} className={styles.main}>
        {children}
      </div>
    </div>
  );
};

export default wrapStore(BaseLayout, BaseLayoutStore);
